import { render, staticRenderFns } from "./ConferenceRoomsStatistic.vue?vue&type=template&id=1b616b64"
import script from "./ConferenceRoomsStatistic.vue?vue&type=script&lang=js"
export * from "./ConferenceRoomsStatistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports